import { render, staticRenderFns } from "./RailwayToursTab.vue?vue&type=template&id=79da7d30&lang=pug&"
import script from "./RailwayToursTab.vue?vue&type=script&lang=ts&"
export * from "./RailwayToursTab.vue?vue&type=script&lang=ts&"
import style0 from "./RailwayToursTab.vue?vue&type=style&index=0&id=79da7d30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports